export default {
  es: require("@fds/wm-shared-formats/resources/date_formats.en.json"),
  fr: require("@fds/wm-shared-formats/resources/date_formats.en.json"),
  it: require("@fds/wm-shared-formats/resources/date_formats.it.json")
};
